export default function buildCoalGaugeConfig (data) {
  return {
    series: [
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        min: 0,
        max: 100,
        splitNumber: 8,
        axisLine: {
          lineStyle: {
            width: 6,
            color: [
              [0.25, '#7CFFB2'],
              [0.5, '#58D9F9'],
              [0.75, '#FDDD60'],
              [1, '#FF6E76']
            ]
          }
        },
        pointer: {
          icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
          length: '12%',
          width: 16,
          offsetCenter: [0, '-60%'],
          itemStyle: {
            color: 'auto'
          }
        },
        axisTick: {
          length: 12,
          lineStyle: {
            color: 'auto',
            width: 2
          }
        },
        splitLine: {
          length: 20,
          lineStyle: {
            color: 'auto',
            width: 5
          }
        },
        axisLabel: {
          color: '#fff',
          fontSize: 16,
          distance: -60,
          formatter: function (value) {
            if (value === 25) {
              return '25';
            } else if (value === 50) {
              return '50';
            } else if (value === 75) {
              return '75';
            } else if (value === 100) {
              return '100';
            }
            return '';
          }
        },
        title: {
          offsetCenter: [0, '-26%'],
          fontSize: 16,
          color: '#fff'
        },
        detail: {
          fontSize: 28,
          offsetCenter: [0, '0%'],
          valueAnimation: true,
          color: 'auto'
        },
        data: [
          {
            value: data,
            name: '已用配额(%)'
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_coal_gauge.js